<template>
  <a :href="url" target="_blank">ログインでお困りの場合はこちら</a>
</template>


<script>
export default {
  props: {
    path: {
      type: String,
    },
  },
  computed: {
    url() {
      if (!this.path) {
        return process.env.VUE_APP_FAQ_URL_BASE
      } else {
        return process.env.VUE_APP_FAQ_URL_BASE + this.path
      }
    },
  },
}
</script>
